import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { applyListParams } from "../_shared";
import { decorateJob, jobsListSortMap, jobsSearchCols } from "./_helpers";

export const jobs_approved: Query<Ctx> = async ({ sb }, params) => {
  let query = sb.from("v_jobs_list").select("*").eq("review_status", "approved");
  query = applyListParams(query, params, {
    search: jobsSearchCols,
    sort: {
      map: jobsListSortMap,
      default: [{ column: "updated_at", ascending: false }],
    },
  });
  const { data } = await query;
  if (!data) return [];
  return data.map(decorateJob);
};
